import React from 'react';
import { openCalendlyPopup } from '../utils/calendly';
import { useLanguage } from '../contexts/LanguageContext';
export function VorteileSection() {
  const {
    t
  } = useLanguage();
  const vorteile = [{
    title: t('benefits.revenue.title'),
    description: t('benefits.revenue.desc')
  }, {
    title: t('benefits.time.title'),
    description: t('benefits.time.desc')
  }, {
    title: t('benefits.relationships.title'),
    description: t('benefits.relationships.desc')
  }, {
    title: t('benefits.transparency.title'),
    description: t('benefits.transparency.desc')
  }, {
    title: t('benefits.scalability.title'),
    description: t('benefits.scalability.desc')
  }, {
    title: t('benefits.data.title'),
    description: t('benefits.data.desc')
  }];
  return <section className="py-16 lg:py-24 bg-gradient-to-br from-[#1a1f36] to-[#111827]" data-id="element-277">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
        <h2 className="text-2xl lg:text-3xl font-bold text-white mb-8 text-center" data-id="element-279">
          {t('benefits.title')}
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-280">
          {vorteile.map((vorteil, index) => <div key={index} className="flex items-start gap-3" data-id="element-281">
              <div className="w-6 h-6 rounded-full bg-[#ff6b35]/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-282">
                <div className="w-2 h-2 rounded-full bg-[#ff6b35]" data-id="element-283" />
              </div>
              <div data-id="element-284">
                <div className="text-white font-semibold mb-1" data-id="element-285">
                  {vorteil.title}
                </div>
                <div className="text-gray-400 text-sm" data-id="element-286">
                  {vorteil.description}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}